import { Exception } from "./Exception";

export class EnvironmentNotSelectedException extends Exception {
    constructor(msg: string) {
        super(msg);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, EnvironmentNotSelectedException.prototype);
    }
}